import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "brands-page" }
const _hoisted_2 = { class: "brands-header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "page-subtitle" }
const _hoisted_6 = { class: "brands-content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "brands-list" }
const _hoisted_9 = { class: "brands-grid" }
const _hoisted_10 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_11 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_BrandCard = _resolveComponent("BrandCard")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('brands.allBrands')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('brands.pageSubtitle')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": _ctx.$t('common.noMoreData'),
            onLoad: $setup.onLoad
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.brandList, (brand) => {
                  return (_openBlock(), _createBlock(_component_BrandCard, {
                    key: brand.id,
                    brand: brand,
                    onClick: ($event: any) => ($setup.handleBrandClick(brand))
                  }, null, 8, ["brand", "onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["loading", "finished", "finished-text", "onLoad"])
        ]),
        (_ctx.loading && !$setup.brandList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_van_loading, { size: "24px" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.loading')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && !$setup.brandList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_van_empty, {
                description: _ctx.$t('brands.noBrandsFound'),
                image: "search"
              }, null, 8, ["description"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}